export default "__VITE_ASSET__C_Oo6zT___"